import {add} from '@elements/scroll-animations';
import {findAll, addClass, closest, find, on, findIn, findAllIn} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";
import {onEnterViewPort} from '@elements/viewport-utils';

let selectors = {
    base: '.js-show-on-click',
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let target = find(baseElement.getAttribute('data-show-on-click-target'));
        let buttonText = find(baseElement.getAttribute('data-show-on-click-button-text'));
        let form = closest('form', baseElement);

        if(target) {
            on('click', function(evt) {
                evt.preventDefault();
                target.removeAttribute('hidden');
                buttonText.removeAttribute('hidden');
                addClass('has-additional-text', closest('button', buttonText));
                baseElement.setAttribute('hidden', true);


                if(form) {
                    let hiddenEditInput = findIn('.js-hidden-edit-input', form);

                    if(!hiddenEditInput) {
                        //add hidden input to form for backend
                        let hiddenInput = document.createElement('input');
                        hiddenInput.setAttribute('type', 'hidden');
                        hiddenInput.setAttribute('name', 'edit');
                        hiddenInput.setAttribute('value', '1');
                        hiddenInput.classList.add('js-hidden-edit-input');
                        form.appendChild(hiddenInput);
                    }
                }
            }, baseElement)
        }
    });
}